import React, { useState, useEffect } from "react"; 
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import swal from "sweetalert";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import { 
  User, 
  Anchor, 
  MapPin, 
  Calendar, 
  History, 
  ChevronRight,
  Mail,
  Phone
} from 'lucide-react';

const Profile = () => {
 const API_URL = process.env.REACT_APP_API_BASE_URL;
  const [userData, setUserData] = useState(null);
  const [formData, setFormData] = useState({});
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    const storedData = localStorage.getItem("user");
    if (storedData) {
      const parsed = JSON.parse(storedData);
      setUserData(parsed);
      setFormData(parsed);
    }
  }, []);

  const handleEditClick = () => setIsEditing(true);

  const handleCancel = () => {
    setFormData(userData);
    setIsEditing(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    try {
     if (!/^\d{10}$/.test(formData.mobileNumber)) {
  alert("Please enter valid 10-digit mobile number");
  return;
}
      await fetch(`${API_URL}User/InsertSignupuser`, {
        method: "Post",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ...formData, id: userData.id }),
      });

      setUserData(formData);
      localStorage.setItem("user", JSON.stringify(formData));
      setIsEditing(false);
swal("Success!", "Profile updated", "success");
      
    } catch (err) {
      console.error(err);
       swal("Error!", "Update failed", "error");
      
    }
  };

  if (!userData) {
    return <p style={{padding: "20px"}}>Loading user data...</p>;
  }

  return (
    <>
      {/* <Header /> */}
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <div className="ib_profile_main_wrapper">
        <div className="ib_profile_content_container">

          <header className="ib_profile_top_header">
            <div className="ib_profile_header_text_group">
              <h1 className="ib_profile_main_title">User Profile</h1>
              <p className="ib_profile_main_subtitle">
                Manage your account settings and boat booking preferences.
              </p>
            </div>

            {!isEditing ? (
              <button className="ib_profile_action_btn" onClick={handleEditClick}>
                Edit Profile
              </button>
            ) : (
              <>
                <button className="ib_profile_action_btn" onClick={handleSave}>
                  Save
                </button>
                <button className="ib_profile_action_btn" onClick={handleCancel}>
                  Cancel
                </button>
              </>
            )}
          </header>

          {/* Profile Card */}
          <section className="ib_profile_base_card">
            <div className="ib_profile_hero_banner">
              <div className="ib_profile_image_holder">
                <img
                  src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=200&h=200&fit=crop"
                  alt="User Avatar"
                  className="ib_profile_user_avatar"
                />
              </div>
            </div>

            <div className="ib_profile_inner_body">
              <div className="ib_profile_user_branding">
                <h2 className="ib_profile_display_name">{userData.name}</h2>

                <div className="ib_profile_quick_meta">
                  <span className="ib_profile_meta_row">
                    <MapPin size={14} /> {userData.companyAddress}
                  </span>

                  <span className="ib_profile_meta_row">
                    <Calendar size={14} /> 
                    Joined {new Date(userData.createdAt).toDateString()}
                  </span>
                </div>
              </div>

              <div className="ib_profile_stats_row">
                <div className="ib_profile_stat_item">
                  <p className="ib_profile_stat_tag">User ID</p>
                  <p className="ib_profile_stat_number">{userData.id}</p>
                </div>

                <div className="ib_profile_stat_item">
                  <p className="ib_profile_stat_tag">Status</p>
                  <p className="ib_profile_stat_number">
                    {userData.isActive ? "Active" : "Inactive"}
                  </p>
                </div>
              </div>
            </div>
          </section>

          <div className="ib_profile_dual_grid">

            {/* Personal Details */}
            <div className="ib_profile_base_card" style={{ padding: '24px' }}>
              <h3 className="ib_profile_section_heading">
                <div className="ib_profile_icon_square"><User size={18} /></div>
                Personal Details
              </h3>

              {/* Name */}
              <div className="ib_profile_data_point">
                <label className="ib_profile_label_text">Full Name</label>
                {isEditing ? (
                  <input name="name" value={formData.name || ""} onChange={handleChange}/>
                ) : (
                  <p className="ib_profile_value_text">{userData.name}</p>
                )}
              </div>

              {/* Email */}
              <div className="ib_profile_data_point">
                <label className="ib_profile_label_text">
                  <Mail size={10} /> Email Address
                </label>
                {isEditing ? (
                  <input name="emailId" value={formData.emailId || ""} onChange={handleChange}/>
                ) : (
                  <p className="ib_profile_value_text">{userData.emailId}</p>
                )}
              </div>

              {/* Mobile */}
              <div className="ib_profile_data_point">
                <label className="ib_profile_label_text">
                  <Phone size={10} /> Contact Number
                </label>
                {isEditing ? (
                 <input
  type="text"
  name="mobileNumber"
  value={formData.mobileNumber || ""}
  maxLength={10}
  onChange={(e) => {
    const value = e.target.value;

    // Allow only numbers
    if (/^\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        mobileNumber: value,
      }));
    }
  }}
/>
                ) : (
                  <p className="ib_profile_value_text">+91 {userData.mobileNumber}</p>
                )}
              </div>

              {/* Company */}
              <div className="ib_profile_data_point">
                <label className="ib_profile_label_text">Company</label>
                {isEditing ? (
                  <input name="companyName" value={formData.companyName || ""} onChange={handleChange}/>
                ) : (
                  <p className="ib_profile_value_text">{userData.companyName}</p>
                )}
              </div>

              {/* GST */}
              <div className="ib_profile_data_point" style={{ marginBottom: 0 }}>
                <label className="ib_profile_label_text">GST</label>
                {isEditing ? (
                  <input name="gst" value={formData.gst || ""} onChange={handleChange}/>
                ) : (
                  <p className="ib_profile_value_text">{userData.gst}</p>
                )}
              </div>
            </div>

            {/* Voyages (unchanged) */}
            <div className="ib_profile_base_card" style={{ padding: '24px' }}>
              <h3 className="ib_profile_section_heading">
                <div className="ib_profile_icon_square"><History size={18} /></div>
                Recent Voyages
              </h3>

              <div className="ib_profile_activity_stack">
                {[
                  { boat: 'Gateway Luxury Cruiser', date: 'Oct 12, 2023', type: 'Yacht' },
                  { boat: 'Backwater Serenity', date: 'Sep 05, 2023', type: 'Houseboat' },
                  { boat: 'Goa Speed Racer', date: 'Aug 20, 2023', type: 'Speedboat' }
                ].map((booking, idx) => (
                  <div key={idx} className="ib_profile_activity_row">
                    <div className="ib_profile_activity_info">
                      <div className="ib_profile_activity_icon_bg">
                        <Anchor size={16} />
                      </div>
                      <div>
                        <p className="ib_profile_boat_name">{booking.boat}</p>
                        <p className="ib_profile_boat_details">
                          {booking.type} • {booking.date}
                        </p>
                      </div>
                    </div>
                    <ChevronRight size={16} color="#d1d5db" />
                  </div>
                ))}
              </div>
            </div>

          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default Profile;
